import { Children, isValidElement, type ReactNode } from 'react';

import { isSlot } from '../../../core/utils/is-slot.js';
import { Pan } from '../slots/chart-interactions/Pan.js';
import { Zoom } from '../slots/chart-interactions/Zoom.js';
import { ZoomX } from '../slots/chart-interactions/ZoomX.js';
import { type ChartInteractionsConfig } from '../types/interactions.js';

/**
 * Generate chart config based on slots
 * @param children - CharInteraction children
 * @returns ChartInteraction slot config
 */
export const iterateChartInteractionsSlots = (children: ReactNode) => {
  let interactions: ChartInteractionsConfig = {};

  Children.forEach(children, (childInteractions) => {
    if (isValidElement(childInteractions)) {
      /* eslint-disable-next-line @typescript-eslint/no-deprecated */
      if (isSlot(childInteractions, Zoom)) {
        interactions = { ...interactions, zoom: { enabled: true } };
        /* eslint-disable-next-line @typescript-eslint/no-deprecated */
      } else if (isSlot(childInteractions, ZoomX)) {
        interactions = { ...interactions, zoomX: { enabled: true } };
        /* eslint-disable-next-line @typescript-eslint/no-deprecated */
      } else if (isSlot(childInteractions, Pan)) {
        interactions = { ...interactions, pan: { enabled: true } };
      }
    }
  });

  return interactions;
};
